import { providers } from './providers';
import { premiumProviders, standardProviders } from './premiumProviders';

export interface UnifiedProvider {
  id: number;
  name: string;
  category: string;
  description: string;
  basePrice: number;
  priceRange?: string;
  rating: number;
  reviewCount: number;
  available: boolean;
  image: string;
  avatar?: string;
  completedJobs: number;
  responseTime: string;
  skills: string[];
  serviceArea?: string;
  badge?: string;
  images?: string[];
}

const normalizedPremium: UnifiedProvider[] = premiumProviders.map((p) => ({
  id: p.id,
  name: p.name,
  category: p.category,
  description: p.description,
  basePrice: p.basePrice,
  priceRange: p.priceRange,
  rating: p.rating,
  reviewCount: p.reviewCount,
  available: p.available,
  image: p.avatar,
  avatar: p.avatar,
  completedJobs: p.completedJobs,
  responseTime: p.responseTime,
  skills: p.skills,
  serviceArea: p.serviceArea,
  badge: p.badge,
  images: p.images,
}));

const normalizedStandard: UnifiedProvider[] = standardProviders.map((p) => ({
  id: p.id,
  name: p.name,
  category: p.category,
  description: p.description,
  basePrice: p.basePrice,
  rating: p.rating,
  reviewCount: p.reviewCount,
  available: p.available,
  image: p.image,
  completedJobs: p.completedJobs,
  responseTime: '1 hora',
  skills: [],
  serviceArea: p.serviceArea,
}));

const normalizedLegacy: UnifiedProvider[] = providers.map((p) => ({
  id: p.id,
  name: p.name,
  category: p.category,
  description: p.description,
  basePrice: p.basePrice,
  rating: p.rating,
  reviewCount: p.reviewCount,
  available: p.available,
  image: p.image,
  completedJobs: p.completedJobs,
  responseTime: p.responseTime,
  skills: p.skills,
}));

export const allProviders: UnifiedProvider[] = [
  ...normalizedPremium,
  ...normalizedStandard,
  ...normalizedLegacy,
];

export function findProviderById(id: number): UnifiedProvider | undefined {
  return allProviders.find((p) => p.id === id);
}
